// extracted by mini-css-extract-plugin
module.exports = {"pageWrapper":"feature-brand-page_pageWrapper__rd1_j"};